export default "assets/images/favicon-096dc7c2.png";